import sortBy from "lodash/sortBy";

export const PRIMARIES = [
  { value: "squat", label: "Squat" },
  { value: "bench", label: "Bench Press" },
  { value: "deadlift", label: "Deadlift" },
];

// Catalog filter categories. Labels come from
// coaching-portal.json → exerciseLibraryCatalog.categories.<lowercased value>,
// so every entry here needs a matching key there or the filter renders the raw
// key. Kept in sync with MUSCLE_GROUP_SELECT_ARRAY in constants.js.
export const ACCESSORIES = [
  "Biceps",
  "Triceps",
  "Back",
  "Glutes",
  "Abductors",
  "Adductors",
  "Calves",
  "Quadriceps",
  "Hamstrings",
  "Legs",
  "Abs",
  "Forearms",
  "Chest",
  "Shoulders",
  "Others",
];

export const OLYMPICS = [
  { value: "clean", label: "Clean" },
  { value: "jerk", label: "Jerk" },
  { value: "snatch", label: "Snatch" },
];

export const STRONGMAN = [
  { value: "overheadPress", label: "Overhead Press" },
  { value: "other", label: "Other" },
];

export const filterCatalog = (catalog, filter, search) => {
  if (!catalog) return [];

  const isPrimary = [
    "squat",
    "bench",
    "deadlift",
    "clean",
    "jerk",
    "snatch",
    "overheadPress",
    "other",
  ].includes(filter);
  const primaryFilter = isPrimary ? filter : "assistant";

  return catalog.filter((exercise) => {
    const { movement, primary, primaryMuscleGroup } = exercise;

    // catalog exercise primary matches filter (squat, bench, deadlift, assistant)
    const primaryMatch = primary === primaryFilter;
    // catalog exercise primaryMuscleGroup matches filter
    let muscleMatch;
    if (isPrimary) {
      muscleMatch = true;
    } else if (filter === "Other") {
      muscleMatch = !primaryMuscleGroup;
    } else {
      muscleMatch = primaryMuscleGroup === filter;
    }
    // match the name if the user is using the search input
    const nameMatch = search
      ? movement.trim().toLowerCase().includes(search.trim().toLowerCase())
      : true;

    return primaryMatch && muscleMatch && nameMatch;
  });
};

// properties from catalog exercises that aren't needed in the exercise library
// (`tags` is preset membership on the master catalog and must not leak into a
// coach's library — see msb-api build-library-from-presets.js)
const keysToRemove = ["_id", "primary", "tags"];

export const buildLibraryArray = (exercises, repMaximum = null) => {
  return exercises.map((ex) => {
    const exercise = { repMaximum, ...ex };
    keysToRemove.forEach((key) => {
      delete exercise[key];
    });
    return exercise;
  });
};

export const sortLibraryArray = (library) => {
  return sortBy(library, [({ movement }) => String(movement).toLowerCase()]);
};
